import { SelectItem } from "primeng/api";

export interface IReport extends SelectItem {
    name: string,
    parameters: IReportParameter[];
}

export interface IReportParameter {
    name: string;
    displayName?: string;
    value?: any;
    controlType?: string;
    isRequired?: boolean;
    options?: SelectItem[];
    parameterType: string;
}

export enum ReportExportType {
    Pdf = 'Pdf',
    Excel = 'Excel',
    Word = 'Word'
}

export enum ParameterType {
    EndDate = 'EndDate',
    StartDate = 'StartDate'
}

export enum ReportType {
    VideoSessionHistory = 'VideoSessionHistory',
    ExecutiveSitrepReport = 'ExecutiveSitRepReport'
}
